import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'lib';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  title = '';
  androidLink = '';
  iosLink = '';
  isDisplay = false;

  constructor(
    private configService: AppConfigService
  ) { }

  ngOnInit() {
    this.configService.getApp()
      .subscribe(config => {
        this.title = config.title;
        this.androidLink = config.mobileLink.android;
        this.iosLink = config.mobileLink.ios;
      });
  }

  open() {
    this.isDisplay = !this.isDisplay;
  }
}
